import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-aktionen2';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungAktionen2Effects {

    VeranstaltungAktionen2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_AKTIONEN2),
        mergeMap((x: ac.GetVeranstaltungAktionen2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungAktionen2(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungAktionen2ErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungAktionen2FehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AktionenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AktionenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AktionenQueryService);
        }
        return this.service;
    }
}
